import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14 5.02v5.96a.6.6 0 0 1-.309.524l-5.4 3a.6.6 0 0 1-.582 0l-5.4-3A.6.6 0 0 1 2 10.98V5.02a.6.6 0 0 1 .309-.525l5.4-3a.6.6 0 0 1 .582 0l5.4 3a.6.6 0 0 1 .309.524"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m2.353 4.862 5.356 2.976a.6.6 0 0 0 .583 0l5.375-2.986M8 14V8"
    }, null, -1)
  ]))]))
}
export default { render: render }